import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const CreateSupplier = React.createContext({});
export let createSupplierMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMCreateSupplier = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createSupplierMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createSupplierMachine);

  return {
    createSupplierMachine,
    createSupplierState: state,
    createSupplierSend: send,
  };
};
